import * as fromDatatype from "../datatype-library/index";

// linking from other database tables

export interface app_login_principal_RowInterface {
  guid: fromDatatype.VarcharDatatypeInterface;
  subject_guid: fromDatatype.VarcharDatatypeInterface;
  principal_type: fromDatatype.VarcharDatatypeInterface;
  principal_id: fromDatatype.VarcharDatatypeInterface;
  principal_value: fromDatatype.TextDatatypeInterface;
  credential: fromDatatype.TextDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  valid_date_start: fromDatatype.TimestampTzDatatypeInterface;
  valid_date_end: fromDatatype.TimestampTzDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
}

export class app_login_principal_RowClass
  implements app_login_principal_RowInterface
{
  guid: fromDatatype.VarcharDatatypeInterface;
  subject_guid: fromDatatype.VarcharDatatypeInterface;
  principal_type: fromDatatype.VarcharDatatypeInterface;
  principal_id: fromDatatype.VarcharDatatypeInterface;
  principal_value: fromDatatype.TextDatatypeInterface;
  credential: fromDatatype.TextDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  valid_date_start: fromDatatype.TimestampTzDatatypeInterface;
  valid_date_end: fromDatatype.TimestampTzDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
}
